const GOOGLE_MAP_API_KEY_MAP = {
	dev: 'AIzaSyBIEB2bD42FcB3scU6m3qjhMUFvfDD7Y9o',
	demo: 'AIzaSyBIEB2bD42FcB3scU6m3qjhMUFvfDD7Y9o',
	production: 'AIzaSyDYaLEin5fR1YX8RVl2FUeTOF1TTC9Rp2w',
};

export const GOOGLE_MAP_API_KEY = GOOGLE_MAP_API_KEY_MAP[process.env.API];

const INSTAGRAM_CLIENT_ID_MAP = {
	dev: '1d494b437b3a418a833e716129408e8c',
	demo: '1d494b437b3a418a833e716129408e8c',
	production: '1d494b437b3a418a833e716129408e8c',
};

export const INSTAGRAM_CLIENT_ID = INSTAGRAM_CLIENT_ID_MAP[process.env.API];



// WEBPACK FOOTER //
// ./src/util/key.js